import OpOrderBy from "./index.vue";
var oporderby = {
  install: function install(Vue) {
    Vue.component("OpOrderBy", OpOrderBy);
  }
};
export default oporderby;